import { render, staticRenderFns } from "./PatientTopDetail.vue?vue&type=template&id=c8d8c756&scoped=true"
import script from "./PatientTopDetail.vue?vue&type=script&lang=js"
export * from "./PatientTopDetail.vue?vue&type=script&lang=js"
import style0 from "./PatientTopDetail.vue?vue&type=style&index=0&id=c8d8c756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d8c756",
  null
  
)

export default component.exports